export const UploadIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6.5L10 2.49998" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14 6.5L9.99996 2.49996" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10 14.5L10 2.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 17.5L15 17.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
